export default import.meta.ROLLDOWN_FILE_URL_$HDoUByStEEEQIDccC83eQ